export default {
  changeToken (ctx, token) {
    ctx.commit('changeToken', token)
  },
  changeDeviceType (ctx, deviceType) {
    ctx.commit('changeDeviceType', deviceType)
  }
}
